import { z } from 'zod';
import { sectionOConsistency } from '../oasis-rules/consistency/section-o';
export const baseM2200 = z.object({
    m2200: z.string().optional(),
    m2200Na: z.union([z.string(), z.boolean()]).optional(),
});
export const baseM2200Refined = baseM2200.refine((data) => data.m2200 || data.m2200Na, {
    message: 'Required',
    path: [],
});
export const o0110 = {
    o0110CancerTreatment: z.array(z.string()).optional(),
    o0110Respiration: z.array(z.string()).optional(),
    o0110Other: z.array(z.string()).optional(),
    o0110None: z.array(z.string()).optional(),
};
export const baseO0110 = z.object(o0110);
export const processedO0110 = z.preprocess((input, ctx) => {
    sectionOConsistency({ input, ctx, field: 'o0110' });
    return input;
}, baseO0110);
export const SectionO = {
    o0110: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
        fields: {
            a1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            a1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            a2a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            a2c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            a3a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            a3c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            a10a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            a10c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            b1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            b1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            c1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            c1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            c2a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            c2c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            c3a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            c3c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            c4a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            c4c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            d1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            d1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            d2a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            d2c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            d3a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            d3c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            e1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            e1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            f1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            f1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            g1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            g1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            g2a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            g2c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            g3a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            g3c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            h1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            h1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            h2a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            h2c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            h3a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            h3c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            h4a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            h4c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            h10a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            h10c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            i1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            i1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            j1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            j1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            j2a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            j2c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            j3a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            j3c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            o1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            o1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            o2a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            o2c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            o3a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            o3c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            o4a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            o4c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
            z1a: {
                version: ['*'],
                timepoint: ['soc', 'roc'],
            },
            z1c: {
                version: ['*'],
                timepoint: ['dsch'],
            },
        },
    },
    o0350: {
        version: ['e1'],
        timepoint: ['tr', 'trd', 'dsch', 'dth'],
    },
    m1041: {
        version: ['e1'],
        timepoint: ['tr', 'trd', 'dsch'],
    },
    m1046: {
        version: ['e1'],
        timepoint: ['tr', 'trd', 'dsch'],
    },
    m2200: {
        version: [],
        timepoint: [],
    },
};
// O-M1041_IN_INFLNZ_SEASON-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"No"},{"value":"1","label":"Yes"}]
// O-M1046_INFLNZ_RECD_CRNT_SEASON-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"01","label":"Yes; received from your agency during this episode of care (SOC/ROC to Transfer/Discharge)"},{"value":"02","label":"Yes; received from your agency during a prior episode of care (SOC/ROC to Transfer/Discharge)"},{"value":"03","label":"Yes; received from another health care provider (for example, physician, pharmacist)"},{"value":"04","label":"No; patient offered and declined"},{"value":"05","label":"No; patient assessed and determined to have medical contraindication(s)"},{"value":"06","label":"No; not indicated - patient does not meet age/condition guidelines for influenza vaccine"},{"value":"07","label":"No; inability to obtain vaccine due to declared shortage"},{"value":"08","label":"No; patient did not receive the vaccine due to reasons other than those listed in responses 4 - 7"},{"value":"^","label":"Blank (skip pattern)"}]
// O-O0110A10A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110A10C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110A1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110A1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110A2A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110A2C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110A3A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked  (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110A3C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110B1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110B1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110C1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110C1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110C2A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110C2C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110C3A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110C3C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110C4A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110C4C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110D1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110D1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110D2A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110D2C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110D3A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110D3C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110E1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110E1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110F1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110F1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110G1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110G1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110G2A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110G2C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110G3A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110G3C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110H10A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110H10C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110H1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110H1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110H2A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110H2C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110H3A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110H3C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110H4A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110H4C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110I1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110I1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110J1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110J1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110J2A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110J2C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110J3A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110J3C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110O1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110O1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110O2A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110O2C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110O3A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110O3C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110O4A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110O4C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110Z1A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0110Z1C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// O-O0350-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"-","label":"Not assessed/no information"},{"value":"0","label":"No, patient is not up to date"},{"value":"1","label":"Yes, patient is up to date"}]
